import User from "../../icons/User";
import Questionmark from "../../icons/Questionmark";
import UserCircle from "../../icons/UserCircle";
import MoneyCoin from "../../icons/MoneyCoin";
import Map from "../../icons/Map";
import Attorney from "../../icons/Attorney";
import Documents from "../../icons/Documents";
import Hammer from "../../icons/Hammer";
import Calendar from "../../icons/Calender";
import Ticket from "../../icons/Ticket";
import ThumbsUp from "../../icons/ThumbsUp";

interface AdminNavItem {
  icon: React.ReactNode;
  label: string;
  path: string;
}

export const adminNavItems: AdminNavItem[] = [
  {
    icon: <User />,
    label: "Users",
    path: "/admin/users",
  },
  {
    icon: <Attorney />,
    label: "Attorneys",
    path: "/admin/attorneys",
  },
  {
    icon: <Hammer />,
    label: "Law Firms",
    path: "/admin/law-firms",
  },
  {
    icon: <Calendar />,
    label: "Attorney Appointments",
    path: "/admin/attorney-appointments",
  },
  {
    icon: <ThumbsUp />,
    label: "Attorney Reviews",
    path: "/admin/attorney-reviews",
  },
  {
    icon: <Map />,
    label: "States",
    path: "/admin/states",
  },
  {
    icon: <MoneyCoin />,
    label: "Attorney Payouts",
    path: "/admin/attorney/payouts",
  },
  {
    icon: <Documents />,
    label: "Library Groups",
    path: "/admin/library-groups",
  },
  {
    icon: <Ticket />,
    label: "Discounts",
    path: "/admin/discounts",
  },
];

export const bottomAdminNavItems: AdminNavItem[] = [
  {
    icon: <Questionmark />,
    label: "Help",
    path: "/admin/help",
  },
  {
    icon: <UserCircle />,
    label: "Account",
    path: "/admin/account",
  },
];
